var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPintrst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BABABA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,1.7C17.5,0.6,15.4,0,13,0c-2.4,0-4.5,0.6-6.5,1.7c-2,1.2-3.6,2.7-4.7,4.7C0.6,8.5,0,10.6,0,13 c0,2.6,0.7,5,2.1,7.2c1.4,2.1,3.3,3.7,5.6,4.8c0-1.2,0-2.2,0.2-3l1.7-7.1c-0.3-0.6-0.4-1.2-0.4-2.1c0-1,0.2-1.8,0.7-2.4 c0.5-0.6,1.1-1,1.8-1c0.6,0,1,0.2,1.3,0.6c0.3,0.4,0.5,0.8,0.5,1.4c0,0.4-0.1,0.8-0.2,1.3c-0.1,0.5-0.3,1.1-0.5,1.7 c-0.2,0.7-0.4,1.2-0.4,1.6c-0.2,0.7,0,1.3,0.4,1.8c0.4,0.5,1,0.7,1.7,0.7c1.2,0,2.2-0.7,3-2c0.8-1.3,1.2-3,1.2-4.9 c0-1.5-0.5-2.7-1.4-3.6c-1-0.9-2.3-1.4-4-1.4c-1.9,0-3.5,0.6-4.6,1.8c-1.2,1.2-1.8,2.7-1.8,4.4c0,1,0.3,1.9,0.9,2.6 c0.2,0.2,0.3,0.5,0.2,0.7c0,0.1-0.1,0.2-0.1,0.5c-0.1,0.3-0.1,0.4-0.1,0.5c-0.1,0.4-0.3,0.5-0.6,0.3c-0.9-0.4-1.5-1-2-1.9 c-0.5-0.9-0.7-1.9-0.7-3.1c0-0.8,0.1-1.5,0.4-2.3S5.2,8.7,5.7,8c0.5-0.7,1.1-1.3,1.8-1.9c0.7-0.5,1.6-1,2.6-1.3 c1-0.3,2.1-0.5,3.3-0.5c1.6,0,3,0.4,4.3,1.1c1.3,0.7,2.2,1.6,2.9,2.8c0.7,1.1,1,2.3,1,3.6c0,1.7-0.3,3.2-0.9,4.6 c-0.6,1.4-1.4,2.4-2.5,3.2c-1.1,0.8-2.3,1.2-3.7,1.2c-0.7,0-1.3-0.2-1.9-0.5c-0.6-0.3-1-0.7-1.2-1.1c-0.5,2-0.8,3.2-0.9,3.6 c-0.2,0.8-0.7,1.7-1.3,2.8c1.2,0.4,2.4,0.5,3.7,0.5c2.4,0,4.5-0.6,6.5-1.7c2-1.2,3.6-2.7,4.7-4.7c1.2-2,1.7-4.2,1.7-6.5 c0-2.4-0.6-4.5-1.7-6.5C23.1,4.5,21.5,2.9,19.5,1.7z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrst);
export default __webpack_public_path__ + "static/media/pintrst.c89719a941293e37c5f0f91c98ceec6d.svg";
export { ForwardRef as ReactComponent };